export default __webpack_public_path__ + "images/R7.97d1abb.png";